<template>
  <div>
    <Grid
      ref="grid"
      :service="service"
      :route_grid_path="`/students/grid`"
      order_column="name"
      hide_actions="true"
    >
      <template v-slot:gridThead>
        <vs-th key="student_name" sort-key="name">{{ $t('student.name') }}</vs-th>
        <vs-th key="student_email" sort-key="email">{{ $t('student.email') }}</vs-th>
      </template>
      <template v-slot:gridData="props">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in props.data">
          <vs-td width="40%" key="name">
            <span>{{ tr.name }}</span>
          </vs-td>
          <vs-td width="40%" key="email">
            <span>{{ tr.email }}</span>
          </vs-td>
        </vs-tr>
      </template>
    </Grid>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

import TeacherService from '@/services/api/TeacherService'

export default {
  directives: {
    Ripple
  },
  components: {
    BButton,
  },
  data: () => ({
    service: null
  }),
  computed: {


  },
  methods: {
    formatDateTime(timestamp) {
      return this.$utils.format.shortDateWithTime(timestamp)
    },

    refreshGrid() {
      if (this.$refs.grid) {
        this.$refs.grid.fetchGridData()
      }
    }
  },
  beforeMount() {
    this.service = TeacherService.build(this.$vs)
  },
  mounted() {

  }
}
</script>
